import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { OAuthService } from '../../../services/oauth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss', './landing.component.medium.scss']
})
export class LandingComponent implements OnInit {

  constructor(private router: Router, private oAuthService: OAuthService) { }

  get loggedIn() {
    return OAuthService.getAccessToken();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    const logoutUrl = new RegExp('^/logout');
    if (logoutUrl.test(this.router.url)) {
      this.oAuthService.logout();
      this.router.navigate(['/']);
    }
  }

  goDashboard() {
    this.router.navigate(['']);
  }

  changeBackground(): any {
    //why is this empty?
  }

}
